const removeQuotesFromEnds = (string) => {
  return string.replace(/^['"]|['"]$/g, "")
}


export default removeQuotesFromEnds